import React from "react";
import { connect } from "react-redux";

import loader from '../../assets/images/loader.gif'
import "./campaignSearch.css";
import { campaignSearch } from "../../actions/index";
import history from "../../history";

export class CampaignSearch extends React.Component {

  constructor(props) {
    super(props);
    this.searchBox = React.createRef();
    this.searchButton = React.createRef();
    this.state = {
      showError: false,
      errorMessage: ""
    }

  }

  componentDidMount() {
    if (this.props.searchTerm && (!this.props.campaign.uData || !this.props.campaign.uData.length) ) {
      console.log(`Campaign Search: `)
      console.log( this.props)
      this.getInfo()
    }
  }
  handleKeyPressOnInput = (e) => {

    if (e.key === 'Enter') {
      this.getInfo()
    }
  }

  getInfo = () => {
    this.searchButton.current.disabled = true
    this.searchButton.current.innerHTML = `<img src=${loader} alt='loader' width="40%" />`

    let searchTerm = this.searchBox.current.value ? this.searchBox.current.value.trim() : this.props.searchTerm ? this.props.searchTerm.trim() : ''
    history.push(`/campaign/${searchTerm}`)

    if (searchTerm.match(/^[0-9]+$/) !== null || searchTerm.toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi
      )) {

      
      this.props.campaignSearch(searchTerm)
        .then((response) => {
          this.searchButton.current.disabled = false
          this.searchButton.current.innerHTML = "Get Info"
          if (response === 'success') {

            if (!this.props.campaign.uData) {
              console.log('No Results found')
              this.setState({ errorMessage: 'No Results Found!', showError: true })
            } else if (this.props.campaign.cData && !this.props.campaign.cData.schedule) {
              this.setState({ errorMessage: `Campaign created by API with no schedule parameters are not supported yet!`, showError: true })
            } else {
              console.log('Campaign Search Results')
              this.setState({ errorMessage: '', showError: false })
            }
          } else {

            console.log('An error occurred while performing this operation')
            this.setState({ errorMessage: 'An error occurred while performing this operation', showError: true })
          }


        })

    } else {
      this.searchButton.current.disabled = false
      this.searchButton.current.innerHTML = "Get Info"
      this.setState({ errorMessage: 'Enter a valid Campaign ID / Email Address', showError: 'true' })

    }

  }

  render() {
    return (
      <div className="CampaignSearch">
        <div className="CampaignSearch-title">Enter Campaign ID / User Email</div>
        <div className="CampaignSearch-box">
          <input type='text' id="campaignSearch" placeholder="21725498 / user@example.com" 
          onKeyDown={this.handleKeyPressOnInput} ref={this.searchBox} 
          defaultValue={this.props.campaign.search ? this.props.campaign.search : this.props.searchTerm ? this.props.searchTerm : ''}
          autoComplete="off"
          ></input>
          <button id="campaignButton" ref={this.searchButton} onClick={this.getInfo}> Get Info</button>
        </div>


        <div className={`CampaignSearch-Error ${this.state.showError ? 'show' : 'hidden'}`} >{this.state.errorMessage}</div>

      </div>


    );
  }
}


const mapStateToProps = (state) => {
  return { campaign: state.campaign };
};

export default connect(mapStateToProps, { campaignSearch })(CampaignSearch);
